import React, { useContext, useState, useEffect } from 'react';
import { Container, Button } from 'reactstrap';
import { AppContext } from '../../../context/app-context';
import FreeHeader from './FreeHeader';
import FreeQuestion from './FreeQuestion';
import { useDiet } from '../../../hooks/useDiet';
import { sendFirebaseEvent } from '../../../helper/mobile';

const DietPlanAI = () => {

    const [state, dispatch] = useContext(AppContext);
    const [dietaryPreference, setDietaryPreference] = useState();
    const [preferredCuisine, setPreferredCuisine] = useState();
    const [isDisabled, setIsDisabled] = useState(true);
    const { makeDietPayment } = useDiet();

    useEffect(() => {
        const assessment = state.assessment;
        if(assessment.dietaryPreference === 'customise')
            setDietaryPreference("")
        else
            setDietaryPreference(assessment.dietaryPreference)

        if(assessment.preferredCuisine === 'customise')
            setPreferredCuisine("");
        else
            setPreferredCuisine(assessment.preferredCuisine)
    }, []);

    useEffect(() => {
        if(dietaryPreference !== "" && preferredCuisine !== "")
            setIsDisabled(false);
        else
            setIsDisabled(true);
    }, [dietaryPreference, preferredCuisine]);
    
    const handleSelectChange = (e) => { 
        let payloadLet;
        if(e.target.getAttribute('name') === '1')
        payloadLet = { planType:e.target.value };
        else if(e.target.getAttribute('name') === '2'){
            payloadLet = { dietaryPreference:e.target.value };
            setDietaryPreference(e.target.value);
        }
        else if(e.target.getAttribute('name') === '3'){
            payloadLet = { preferredCuisine:e.target.value };
            setPreferredCuisine(e.target.value)
        }
        dispatch({
            type: "ASSESSMENT",
            payload: payloadLet
        });
    }

    const onClickGenerateAI = () => {
        const assessment1 = state.assessment;
        const queData = {
            "assessmentDetails" : {
            "planType": assessment1.planType,
            "preferredCuisine": assessment1.preferredCuisine,
            "dietaryPreference": assessment1.dietaryPreference
        }}
        sendFirebaseEvent('diet_plan_generate_click', 'click_event', 'ai');
        makeDietPayment('one_month_smart_diet_plan', state.user.dietPlanId, queData);
    }
    
    return( 
        <>
            <FreeHeader />
            <Container>
                <FreeQuestion handleSelectChange={handleSelectChange} preSelect={state.assessment} />
            </Container>
            <div className="empty-space-82"></div>
            <div className="fix-div-button">
                <Button className="risk-btn" disabled={isDisabled} onClick={onClickGenerateAI}>Generate my diet plan</Button>
            </div>
        </>
    );
}

export default DietPlanAI